import { ImageViewer } from './ImageViewer'
import { PdfViewer } from './PdfViewer'
import './index.styles.css'
interface Props {
  url: string
  contentType: string
  fileId?: string | null
}

export const ExpenseFileViewer = ({ url, contentType, fileId }: Props) => {
  const isPdf = contentType === 'application/pdf'
  const isImage = contentType.startsWith('image/')

  return (
    <>
      {isPdf && <PdfViewer url={url} initialScale="page-fit" fileId={fileId} />}

      {isImage && <ImageViewer url={url} fileId={fileId} />}
    </>
  )
}
